var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H11C9.89543 1 9 1.89543 9 3V7C9 8.10457 9.89543 9 11 9H23C24.1046 9 25 8.10457 25 7V3C25 1.89543 24.1046 1 23 1Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5H29C30.0609 5 31.0783 5.42143 31.8284 6.17157C32.5786 6.92172 33 7.93913 33 9V37C33 38.0609 32.5786 39.0783 31.8284 39.8284C31.0783 40.5786 30.0609 41 29 41H5C3.93913 41 2.92172 40.5786 2.17157 39.8284C1.42143 39.0783 1 38.0609 1 37V9C1 7.93913 1.42143 6.92172 2.17157 6.17157C2.92172 5.42143 3.93913 5 5 5H9M17 19H25M17 29H25M9 19H9.02M9 29H9.02",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/EmptyList.26da8a08c465cac0f5b036e706f4638e.svg";
export { ForwardRef as ReactComponent };